import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Swal from 'sweetalert2';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { useParams } from 'react-router-dom';
import Badge from 'react-bootstrap/esm/Badge';
import { Comment } from './Comment';
import './SelectedPost.css'
// import { useNavigate } from 'react-router-dom';
export const SelectedPost = () => {
    const navigate = useNavigate();
    const [post, setpost] = useState([]);
    const [user, setuser] = useState([])
    const [profile, setprofile] = useState([])
    const [Loading, setLoading] = useState(true)
    const [newComment, setnewComment] = useState(false)
    const [allusers, setAllusers] = useState([])
    const post_id = useParams().postID
    const getPost = async () => {
        let { data, status } = await axios.get(`https://maestrohub-backend.onrender.com/api/post/${post_id}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        // setpost(data.post);

        if (status === 200) setpost(data.post)
        console.log(post.comments)
    }
    const getAllUsers=async()=>{
        let allprofile = await axios.get("https://maestrohub-backend.onrender.com/api/profile/allusers");
        setAllusers(allprofile.data.allprofiles);
    }
    const getuser = async () => {
        let { data, status } = await axios.get(`https://maestrohub-backend.onrender.com/api/user/you`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        if (status === 200) {
            // console.log(data)
            setuser(data.user)
        }
        // console.log(user)
    }
    const getProfile = async () => {
        let { data, status } = await axios.get("https://maestrohub-backend.onrender.com/api/profile/me", {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        if (status === 200) setprofile(data.profile);
        setLoading(false)
    }
    useEffect(() => {
        if(!localStorage.getItem("maestrohub"))return navigate('/user/login')
        getPost();
        getuser();
        getProfile();
        getAllUsers();
    }, [])

    const handleFollow = async (id) => {
        // console.log("HandleFollow")
        const { data, status } = await axios.put(`https://maestrohub-backend.onrender.com/api/profile/${id}`, {}, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        if (status === 200) Swal.fire(data.msg, "", "info")
        // getUser();
        // setprofile(data.userprofile)
        getProfile();


    }

    const timeDiff = (curr, posted) => {
        var msperMin = 60 * 1000;
        var msperHr = 60 * msperMin;
        var msperDay = 24 * msperHr;
        var msperWeek = 7 * msperDay;
        var msperMonth = 30 * msperDay;
        var msperYear = 365 * msperDay;

        var diff = curr - posted;
        if (diff < msperMin) {
            return Math.round(diff / 1000) === 1 ? (Math.round(diff / 1000) + " second ago") : (Math.round(diff / 1000) + " seconds ago");
        } else if (diff < msperHr) {
            return Math.round(diff / msperMin) === 1 ? (Math.round(diff / msperMin) + " minute ago") : (Math.round(diff / msperMin) + " minutes ago");

        } else if (diff < msperDay) {
            return Math.round(diff / msperHr) === 1 ? (Math.round(diff / msperHr) + " hour ago") : (Math.round(diff / msperHr) + " hours ago");

        } else if (diff < msperWeek) {
            return Math.round(diff / msperDay) === 1 ? (Math.round(diff / msperDay) + " day ago") : (Math.round(diff / msperDay) + " days ago");

        } else if (diff < msperMonth) {
            return Math.round(diff / msperWeek) === 1 ? (Math.round(diff / msperWeek) + " week ago") : (Math.round(diff / msperWeek) + " weeks ago");

        } else if (diff < msperYear) {
            return Math.round(diff / msperMonth) === 1 ? (Math.round(diff / msperMonth) + " month ago") : (Math.round(diff / msperMonth) + " months ago");
        } else {
            return Math.round(diff / msperYear) === 1 ? (Math.round(diff / msperYear) + " year ago") : (Math.round(diff / msperYear) + " years ago");
        }

    }
    const handleViewProfile = async (id) => {
        console.log("clicked",id)
        // return Swal.fire("get","","info")
        let { data, status } = await axios.get(`https://maestrohub-backend.onrender.com/api/profile/users/${id}`)
        console.log(data, status)
        if (status === 200)
        {
            let profile;
            if (data.profile) {
                profile = data.profile._id;
                navigate(`/users/${profile}`)
            }else{
                return Swal.fire(data.msg,"","info")
            }
        } 
            
        
        
    }
    const handleDelete = async (postID) => {
        // e.preventDefault();
        let { data, status } = await axios.delete(`https://maestrohub-backend.onrender.com/api/post/${postID}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        if (status === 200) {
            Swal.fire(data.msg, "", "success");
            // getAllPosts();
            getPost();
        } else {
            Swal.fire("Error", "", "error");
            navigate("/feed");
        }
    }
    const [newcomment, setComment] = useState("");
    const handleCommentChange = (e) => {
        // console.log(user)
        setComment(e.target.value);
    }
    const handlenewCommentSubmit = async () => {
        if (newcomment === "" || newcomment === null || newcomment === undefined) {
            return Swal.fire("Comment can't be empty", "", "warning")
        }
        let { data, status } = await axios.put(`https://maestrohub-backend.onrender.com/api/post/comments/${post_id}/none`, {
            text: newcomment
        }, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        if (status === 200) {
            Swal.fire(data.msg, "", "success");
            getPost();
            // getuser();
            setComment("");
        }
        setnewComment(false)
    }

    const handleCommentDelete = async (id) => {
        {post.comments.map((childcomment) => {
            if(childcomment.parent === id) handleCommentDelete(this, childcomment._id)
        })}
        let { data, status } = await axios.delete(`https://maestrohub-backend.onrender.com/api/post/comments/${post_id}/${id}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
            }
        })
        if (status === 200) {
            Swal.fire(data.msg, "", "success")
            // getPost()
            // navigate(`/p/${post._id}`)
        }
    }
    const [modalShow, setModalShow] = useState(false)
    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>Likes: </h4>
                    {/* {props.likes.map(like=>{
                return <h2>{like}</h2>
              })} */}
                    {props.likes.map((like) => {

                        return allusers.map((profile) => {
                            return profile.user._id === like ? 
                                <Card onClick={() => navigate(`/users/${profile._id}`)}>
                                    <Card.Body style={{
                                        fontWeight: "bold"
                                    }}><img src={`${profile.user.avatar}`} height={"25vh"} width={"30vh"} alt={`${profile.user.name}'s avatar`}></img> {profile.user.name}</Card.Body>
                                </Card>
                            : <></>
                        })
                    })}
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <div>
            {!Loading ? Object.keys(post).length > 0 && post.user && Object.keys(post.user).length > 0 ? <>

                <Card className='post-card' key={post._id}>
                    <Card.Title className='post-title' >{post.title}</Card.Title>
                    <Card.Img variant="top"
                        //  src="https://www.realmadrid.com/StaticFiles/RealMadridResponsive/images/header_logo.svg"
                        src={`${post.image}`}
                        alt={`Image By ${post.user.name} regarding ${post.title}`}
                        
                    />
                    <Card.Body>
                        <Card.Text className='p-2' style={{
                            fontSize: "2.5vh"
                        }}>
                            {post.description}

                        </Card.Text>
                    </Card.Body>
                    <ListGroup className="list-group-flush">
                        <ListGroup.Item style={{
                            fontWeight: "bolder",
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-between",


                        }}>
                            <div style={{
                                cursor: "pointer"
                            }} onClick={handleViewProfile.bind(this, post.user._id)}>
                                <img src={post.avatar} alt="" height={"25vh"} width={"30vh"} /> {post.user.name}{' '}
                                {profile.trainer? <Badge bg='secondary' className='m-2'>Trainer</Badge>:""}

                            </div>
                            {post.user._id === user._id ? "" :
                                <div >
                                    <Button variant={`${profile.following.includes(post.user._id) ? "danger" : "primary"}`} onClick={handleFollow.bind(this, post.user._id)}>{`${profile.following.includes(post.user._id) ? "Unfollow" : "Follow"}`}</Button>
                                </div>}
                        </ListGroup.Item>
                        <ListGroup.Item className="container row likes-comments">

                            <div className='col-3' style={{
                                justifyContent:'center',
                                alignItems:'center',
                                display:'flex',
                                textAlign: "center",
                            }}>

                                {post.likes.includes(user._id) ? <i className="fa-solid fa-heart" style={{
                                    cursor: "pointer",
                                    color: "red"
                                }} onClick={async () => {
                                    let { status } = await axios.put(`https://maestrohub-backend.onrender.com/api/post/likes/${post._id}`, {}, {
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
                                        }
                                    }

                                    );
                                    if (status === 200) getPost();

                                }}></i> : <i className="fa-regular fa-heart" style={{
                                    cursor: "pointer"
                                }} onClick={async () => {
                                    let { status } = await axios.put(`https://maestrohub-backend.onrender.com/api/post/likes/${post._id}`, {}, {
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: `Bearer ${localStorage.getItem("maestrohub")}`
                                        }
                                    });
                                    if (status === 200)
                                        getPost();
                                }}></i>}{' '}<span style={{
                                    cursor: "pointer"
                                }} onClick={()=>setModalShow(true)}>{post.likes.length === 1 ? "1 Like" : `${post.likes.length} Likes`}</span>
                                
                                <MyVerticallyCenteredModal
                            show={modalShow}
                            onHide={() => setModalShow(false)
                            }
                            likes={post.likes}
                        />
                            </div>
                            <div className='col-3' style={{
                                // display:"flex",
                                textAlign: "center",
                                // justifyContent: "center"
                            }}>
                            {!newComment? <Button className='m-2 justify-content-end' onClick={()=>setnewComment(true)}> Add <i class="fa-solid fa-comment"></i></Button>
                                :<></>    }
                            </div>
                            {post.user._id === user._id ? <div className='col-6 justify-content-end' style={{
                                display:'flex'
                            }}>
                                <Button variant='danger' onClick={handleDelete.bind(this, post._id)} >
                                    <i className="fa-solid fa-trash"></i> <span className='post-delete'> Delete Post</span>
                                </Button>
                            </div> : ""}
                        </ListGroup.Item>
                    </ListGroup>
                    {/* <Card.Body className='text-muted'> */}
                            <div className="timer text-muted">

                        {timeDiff(new Date(), new Date(post.createdAt))}
                            </div>
                    {/* </Card.Body> */}
                </Card>
                <div className="container add-comment">
                    <Form.Group className=" mb-3" controlId="exampleForm.ControlTextarea1">
                        {newComment?
                        <>
                        <Form.Label> <h4>New Comment: </h4></Form.Label>
                        <Form.Control name="text" value={newcomment} as="textarea" rows={3} onChange={handleCommentChange} />
                        <div style={{
                            display: "flex",
                            justifyContent: "end"
                        }}>

                            <Button className='m-2' onClick={handlenewCommentSubmit} ><i class="fa-solid fa-share"></i> Comment</Button>
                            <Button variant='secondary' className='m-2' onClick={()=>setnewComment(false)} ><i class="fa-solid fa-close"></i> Cancel</Button>
                        </div>
                            </>:<></>
                        }
                    </Form.Group>
                </div>
                <div className="post-comments">
                <div className="container ">
                    <h3> Comments:</h3>
                </div>
                    
                <div className="container">
                    
                    {post.comments.map(comment=>{
                        if(comment.parent=="0")return <Comment comment={comment}/>
                    })}
                </div>
                    </div>
            </> : "" : ""}
        </div>
    )
}
